import { ConsultationForm, Modal } from '@/components'
import { StyledButton } from '@/components/styles'

const Trigger = props => {
  return <StyledButton {...props}>Оставить заявку</StyledButton>
}

export default function Consultation({ render: TriggerView = Trigger }) {
  return (
    <Modal render={TriggerView} view="appointment">
      <ConsultationForm />
    </Modal>
  )
}
